export default "__VITE_ASSET__55710d5d__"